import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { useParams,Link } from "react-router-dom";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import api from "../../../api";

const EditStudent = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const params = useParams()
  const [message, setMessage] = useState(false)
  const [name, setName] = useState("")
  const [className, setClassName] = useState("")
  const [course, setCourse] = useState("")
  const [email, setEmail] = useState("")
  const [contact, setContact] = useState('')
  const [payment, setPayment] = useState("")
  const [amount, setAmount] = useState("")
  const [paymentID, setPaymentID] = useState("")
  const [dob, setDOB] = useState('')
  const [gender, setGender] = useState('')
  const [fatherName, setFatherName] = useState('')
  const [motherName, setMotherName] = useState('')
  const [category, setCategory] = useState('')
  const [reference, setReference] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
    const data={name,email,contact,payment,dob,gender,fatherName,motherName,category,reference,password}
  useEffect(() => {
      const timer = setTimeout(() => {
        setMessage(false);
      }, 4000);
      return () => clearTimeout(timer);
    }, [message]);
  useEffect(()=>{
    api.get(`${baseUrl}/student/get/?id=${params.id}`)
    .then(res=>{
        setName(res.data.name || '')
        setEmail(res.data.email || '')
        setContact(res.data.contact || '')
        setPayment(res.data.paymentMode?res.data.paymentMode:'online')
        setAmount(res.data.amountPaid || '')
        setClassName(res.data.className || '')
        setCourse(res.data.enrolledCourses?.[res.data.enrolledCourses.length - 1]?.title || '');
        setPaymentID(res.data.paymentId || '')
        setDOB(res.data.dob ?new Date(res.data.dob).toISOString().split('T')[0]:'')
        setGender(res.data.gender || '')
        setFatherName(res.data.fatherName || '')
        setMotherName(res.data.motherName || '')
        setCategory(res.data.category || '')
        setReference(res.data.reference || '')
        setPassword(res.data.password || '')
        setConfirmPassword(res.data.password || '')

    })
    .catch(err=>console.log(err))
  },[]
)

  const handleSubmit = (e) => {
    if(password!==confirmPassword){
      setMessage('Please enter Confirm password same as Password')
    }
    else if(name===""||email===""||contact===""||payment===''||dob===''||gender===''||fatherName===''||motherName===''||
      category===''
    ){
      setMessage('Make sure you enter all required details')
    }
    else{
      axios
      .post(`${baseUrl}/student/update/?id=${params.id}`, data)
      .then((res) => {
        if (res.data === "success") {
          setMessage("Student updated successfully");
        }
        if (res.data === "failed") {
          setMessage("Something went wrong");
        }
      })
      .catch((err) => console.log(err));
    }
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/students' className="text-decoration-none">Students</Link>
              </li>
              <li className="breadcrumb-item active">
                Edit
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user?.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Edit Student</h4>
            <div className="row mb-3">
              <div className="col-lg-4">
                <label htmlFor="name" className="form-label">
                  Student Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="email" className="form-label">
                    Email
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Enter Email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="contact" className="form-label">
                  Contact Number
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="contact"
                  placeholder="Enter contact number"
                  onChange={(e) => setContact(e.target.value)}
                  value={contact}
                />
              </div>
            </div>
            <div className="row mb-3">
            <div className="col-lg-4">
                <label htmlFor="class" className="form-label">
                  Class
                </label>
                <select value={className} onChange={(e)=>setClassName(e.target.value)} className="form-select" id="class" aria-label="Default select example">
                <option hidden>Select Course</option>
                    <option>
                        Class XI
                    </option>
                    <option>
                        Class XII
                    </option>
                    <option>
                        Class XII Passed
                    </option>
                </select>
              </div>
              <div className="col-lg-4">
                <label htmlFor="course" className="form-label">
                  Course
                </label>
                <p>{course}</p>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-4">
                <label htmlFor="payment" className="form-label">
                  Payment
                </label>
                <select value={payment} onChange={(e)=>setPayment(e.target.value)} className="form-select" id="payment" aria-label="Default select example">
                  <option disabled>Select Payment</option>
                    <option value='Cash'>
                        Cash
                    </option>
                    <option value='online'>
                        Online
                    </option>
                </select>
              </div>
              <div className="col-lg-4">
                <label htmlFor="paymentID" className="form-label">
                    Payment ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="paymentID"
                  placeholder="Enter payment ID"
                  onChange={(e) => setPaymentID(e.target.value)}
                  value={paymentID}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="amount" className="form-label">
                    Amount
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="amount"
                  placeholder="Enter amount paid"
                  onChange={(e) => setAmount(e.target.value)}
                  value={amount}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="dob" className="form-label">
                  Date of Birth
                </label>
                <input id='dob' value={dob} type='date' className="form-control" onChange={(e)=>setDOB(e.target.value)}/>
              </div>
              <div className="col-lg-6">
                <label htmlFor="gender" className="form-label">
                    Gender
                </label>
                <select value={gender} onChange={(e)=>setGender(e.target.value)} className="form-select" id="gender" aria-label="Default select example">
                  <option hidden>Select Gender</option>
                    <option value='male'>
                        Male
                    </option>
                    <option value='female'>
                        Female
                    </option>
                    <option value='other'>
                        Other
                    </option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="fatherName" className="form-label">
                  Father Name
                </label>
                <input
                value={fatherName}
                  type="text"
                  className="form-control"
                  id="fatherName"
                  placeholder="Enter Father Name"
                  onChange={(e) => setFatherName(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="motherName" className="form-label">
                    Mother Name
                </label>
                <input
                value={motherName}
                  type="text"
                  className="form-control"
                  id="motherName"
                  placeholder="Enter Mother name"
                  onChange={(e) => setMotherName(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="category" className="form-label">
                  Category
                </label>
                <select value={category} onChange={(e)=>setCategory(e.target.value)} className="form-select" id="category" aria-label="Default select example">
                  <option hidden>Select category</option>
                    <option>
                        General
                    </option>
                    <option>
                        OBC
                    </option>
                    <option>
                        SC
                    </option>
                    <option>
                        ST
                    </option>
                </select>
              </div>
              <div className="col-lg-6">
                <label htmlFor="reference" className="form-label">
                    Reference
                </label>
                <input
                value={reference}
                  type="text"
                  className="form-control"
                  id="reference"
                  placeholder="Enter reference (optional)"
                  onChange={(e) => setReference(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                value={password}
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Enter password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
                <input
                value={confirmPassword}
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  placeholder="Reenter password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button onClick={handleSubmit} className="btn btn-primary mt-4">
              Update
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditStudent;
